import React, { Component, type PropsWithChildren } from 'react';
import { OutboundEventName } from '../types/OutboundEventName';
import { captureException, sentry } from '../utils/errorReporter';
import { sendEventMessage } from '../utils/messages/sendEventMessage';

export class ErrorBoundary extends Component<PropsWithChildren<{ parentOrigin: string }>, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    sentry.onLoad(() => {
      sentry.withScope((scope) => {
        Object.keys(errorInfo).forEach((key) => {
          scope.setExtra(key, errorInfo[key]);
        });

        // NOTE: In development mode, React will rethrow errors caught within an error boundary.
        // This will result in errors being reported twice to Sentry with the above setup, but this won't occur in your production build.
        captureException(error, false);
      });
    });
    // without force loading onLoad listener won't get called
    sentry.forceLoad();

    sendEventMessage(
      OutboundEventName.Crash,
      `ErrorBoundary exception caught. ${error.message}`,
      this.props.parentOrigin,
    );
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
